import pdfMake from 'pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { useStore } from "vuex";
import pdfHeaderFooter from '@/services/utils/pdf/pdfHeaderFooter';
import htmlToPdfMake from 'html-to-pdfmake';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

pdfMake.fonts = {
    SulaimanLipi: {
        normal: 'https://fonts.cdnfonts.com/s/14639/solaimanlipi.woff',
        bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
        italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
        bolditalics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf'
    }
}
const pdfPrinter = () => {
    const store = useStore();
    const {getHeader, getFooter} = pdfHeaderFooter();

    const userName = store.state.user.user.name;

    const exportToPDF = (company,letterData) => {
        var doc = {
            pageSize: 'A4',
            pageMargins: [30, 100, 30, 80],
            header: getHeader(company),
            footer: getFooter(userName),
            content: getContent(letterData),

            styles: {
                header: {
                    fontSize: 20,
                }
            },

            defaultStyle: {
                color: 'black',
                fontSize: 11,
                font: 'SulaimanLipi'
            },

            info: {
                title: letterData.template_name
            }
        }

        const pdfDocGenerator = pdfMake.createPdf(doc);
        pdfDocGenerator.open();
    }

    const getContent = (letterData) => {
        const htmlContent = htmlToPdfMake(letterData.value, {
            defaultStyle: { font: 'SulaimanLipi', fontSize: 11 }
        });

        return [
            ...htmlContent,
            formatSignatureData()
        ];
    }

    const formatSignatureData = () => {

        let signatures = ['HR Manager'];

        return {
            absolutePosition: { x: 60, y: 740 },
            columns: signatures.map(getSingleSignature)
        }
    }

    const getSingleSignature = (title) => {
        return {
            width: '43%',
            stack: [
                {
                    canvas: [
                        {
                            type: 'line',
                            x1: 0,
                            y1: 0,
                            x2: 58,
                            y2: 0,
                            lineWidth: 1
                        }
                    ]
                },
                {
                    margin: [ 0, 5, 0, 0 ],
                    text: `${title} `,
                    color: 'black',
                    bold: true,
                    alignment: 'left',
                }
            ]
        }
    }

    return {
        exportToPDF
    }
}

export default pdfPrinter;